import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useSubscription } from '../contexts/SubscriptionContext';

/**
 * Protected Route Component
 * Redirects to login if user is not authenticated
 */
const ProtectedRoute = ({ children, requireSubscription = false }) => {
  const { isAuthenticated, loading } = useAuth();
  const { isSubscribed } = useSubscription();

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (requireSubscription && !isSubscribed()) {
    return <Navigate to="/subscription" replace />;
  }

  return children;
};

export default ProtectedRoute;
